import React from "react";
import styled from "styled-components";
import i18next from "i18next";
// @ts-ignore
import { CWBModal } from "cwb-react";
import { withI18n } from "react-i18next";
import { Button, ButtonGroup } from "../Common";


const AlertModal = ({
  title,
  message,
  cancelBtnMsg,
  actionBtnMsg,
  closeModal,
  actionBtn,
  icon,
  t,
}: any) => {
  const getIcon = () => {
    //let baseUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";
    if (icon === "warning") return require("./../../images/alert-yellow.svg");
  };

  return (
    <StyledModal
      className={"cwb-modal"}
      title={title}
      body={message}
      hideModal={closeModal}
      isOpen={true}
      buttons={
        <StyledButtonGroup>
          <Button onClick={actionBtn}>
            <StyledSpan>{actionBtnMsg}</StyledSpan>
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            {cancelBtnMsg}
          </Button>
        </StyledButtonGroup>
      }
    >
      {icon && <StyledImgIcon src={getIcon()} />}
      {message}
    </StyledModal>
  );
};

const StyledModal = styled(CWBModal)`
  max-width: 800px !important;
  .modal-body {
    padding: 12px 0 24px 0 !important;
    height: auto !important;
  }

  .modal-content {
    padding-bottom: 20px;
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

const StyledImgIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 5px;
  width: 16px;
`;

const StyledSpan = styled.span`
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  & > img {
    margin-left: 4px;
  }
`;

AlertModal.defaultProps = {
  message: i18next.t("Are you sure"),
};

export default withI18n()(AlertModal);
